var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "stop-item" },
    [
      _c(
        "md-button",
        {
          staticClass: "md-success",
          class: _vm.useIcon
            ? "md-warning md-just-icon md-round"
            : "" + _vm.className,
          attrs: {
            title: "Send Sms to stop contact",
            disabled: !_vm.isSmsEnabled,
          },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.showSendSmsModal($event)
            },
          },
        },
        [_c("span", [_vm._v("Sms Contact")])]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }